import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import EmployeesContainer from './EmployeesContainer'


const EmployeesRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><EmployeesContainer></EmployeesContainer></Provider>
}

EmployeesRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default EmployeesRoot
